import React from "react";

import { capitalize } from "Libs/utils";

import LargeMetric from "./LargeMetric";
import * as S from "./Service.styles";
import { ServiceUnitProps } from "./type";
import { serviceOrder, useAutoscallingValues } from "./util";

const ServiceUnits = ({
  service,
  activities,
  selectedTimeframe,
  onBrush,
  hosts,
  isLoading,
  kind,
  maxZoom,
  deployment
}: ServiceUnitProps) => {
  const { getThreshold } = useAutoscallingValues(service.name);

  const data = service?.metrics || {};

  const hasMetrics = Object.entries(data).some(([, value]) => value.length);

  if (!hasMetrics && !isLoading) return null;

  const orderedMetrics = serviceOrder(data);

  return (
    <>
      <S.ChartLayout>
        <S.GridLG>
          {orderedMetrics.map(([serviceUnit, value]) => {
            const autoscaleConfig = getThreshold({ service, serviceUnit });

            return (
              <LargeMetric
                key={serviceUnit}
                isLoading={isLoading}
                onBrush={onBrush}
                hosts={hosts}
                selectedTimeframe={selectedTimeframe}
                name={serviceUnit}
                value={value}
                kind={kind}
                serviceKind={capitalize(service?.kind || "")}
                activities={activities}
                deployment={deployment}
                maxZoom={maxZoom}
                autoscaleConfig={autoscaleConfig}
              />
            );
          })}
        </S.GridLG>
      </S.ChartLayout>
    </>
  );
};

export default React.memo(ServiceUnits);
